const VisitorsHeader = ({ searchTerm, onSearchChange, total }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0">Visitors ({total})</h4>
      <div className="d-flex gap-2 align-items-center">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search visitors"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default VisitorsHeader;
